import {
  Menu,
  MenuButton,
  IconButton,
  Portal,
  MenuList,
  MenuItem,
  useDisclosure,
  MenuDivider,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons, defaultIconSize } from '../../Icons';
import { UnpackShipmentModal } from '../../shipment/UnpackShipmentModal';
import {
  SampleNextActionProps,
  GeneralSamplesMenuActions,
  useGeneralSampleModals,
} from '../SampleNextAction';
import { usePortalRefValue } from '@texas/hooks/usePortalRef';

export function UnpackShipment(props: SampleNextActionProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();

  const {
    setLostOnOpen,
    updateOwnerOnOpen,
    rejectOnOpen,
    stopFollowOnOpen,
    modals,
  } = useGeneralSampleModals();

  const { ref } = usePortalRefValue();

  if (!props.sampleId || !props.shipmentId) {
    return null;
  }

  return (
    <>
      <Menu isLazy={true}>
        <MenuButton
          as={IconButton}
          size="sm"
          variant="ghost"
          aria-label={t('sample.menu')}
          icon={<Icons.DotsHorizontal boxSize={defaultIconSize} />}
        />
        <Portal containerRef={ref}>
          <MenuList zIndex={10}>
            <MenuItem
              onClick={onOpen}
              icon={<Icons.PackageVariant boxSize={defaultIconSize} />}
            >
              {t('shipment.markShipmentReceived')}
            </MenuItem>
            <MenuDivider />
            <GeneralSamplesMenuActions
              pas={[props.pa!]}
              sampleIds={[props.sampleId]}
              rejectOnOpen={rejectOnOpen}
              setLostOnOpen={setLostOnOpen}
              updateOwnerOnOpen={updateOwnerOnOpen}
              stopFollowOnOpen={
                props.hideStopFollowing ? null : stopFollowOnOpen
              }
            />
          </MenuList>
        </Portal>
      </Menu>

      {modals}
      <UnpackShipmentModal
        isOpen={isOpen}
        onClose={onClose}
        shipmentId={props.shipmentId}
      />
    </>
  );
}
